































import { Component, Vue, Emit, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { ITriagem, Triagem } from '@/types/implements/Triagem'
import { IRequestMessage, RequestMessage } from '@/types/_'

/* EventBus */
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponenteBackofficeAuditoria extends Vue {
  @Prop({ default: false }) disabled: boolean

  triagem: ITriagem = new Triagem()
  loadAuditoria: boolean = false

  get loadingAuditoria() {
    return this.loadAuditoria
  }

  set loadingAuditoria(val: boolean) {
    this.loadAuditoria = val
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  async sendAuditoria() {
    this.loadingAuditoria = true
    const solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    const params: any = {
      solicitacaoId,
      auditada: this.getBackofficeGlobalStore.solicitacao.auditada,
    }

    const response = await this.triagem.solicitacaoAuditada(params)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Auditoria efetuada com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao realizar auditoria.', icon: 'warning', color: '#C62828' })
    }

    this.loadingAuditoria = false
  }
}
